module.exports = __webpack_public_path__ + "img/homeProduct2.dac013a1.png";